// extracted by mini-css-extract-plugin
module.exports = {"image":"sF","hidden":"sG"};